var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat407(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_407"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_407",
    "data-name": 407,
    className: "cls-2",
    d: "M26.91,6.68c-7.06,7.71-2.28,23,1.95,36.48,7,22.27,24.14,57.7,41.43,55.27a15,15,0,0,0,9.3-5.73c3.89-5.31,3.68-13-7.3-46.64C68.42,34.22,65.2,20.83,56.23,11.61,49.06,4.25,35.36-2.55,26.91,6.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat407);
export default __webpack_public_path__ + "static/media/cat_407.ff87101f7852130262a323c54d4aa6fa.svg";
export { ForwardRef as ReactComponent };